var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FilterList',_vm._g({attrs:{"items":_vm.webhooks.webhooksForProject(_vm.project),"id-field":"uuid","selected":_vm.selected,"searchText":"Filter Webhooks","itemSize":40},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('WebhookItem',{attrs:{"webhook":item}})]}}])},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }